// A sound's ••• menu, everywhere a sound shows (SoundActions.menuFor in
// the app's sound_actions.dart). Items are MoreMenu items.
//   Details
//   Download (free or owned) or Buy… (for sale)
//   Add to session… (SI-25)
//   Star or Unstar
//   Share link…
//   then, on your own sounds: Rename…, Set price…, Edit details…
import store from "@/store";
import { apiGet } from "@/services/api/client.js";
import { canBuy, canDownload } from "@/kit/sound.js";
import { getWavDownloadFromProxyWithId } from "@/filters/utils";
import { soundSheets } from "@/shell/soundSheets.js";
import { toast } from "@/shell/toast.js";
import { addToSession, canAddToSession } from "./addToSession.js";

export function download(sound) {
  if (!canDownload(sound)) return false;
  window.location.href = getWavDownloadFromProxyWithId(sound.hash, sound.downloadToken);
  toast(`Downloaded ${sound.title}`);
  return true;
}

export function isStarred(sound) {
  return !!sound && store.getters.isLoopStarred(sound.hash);
}

export function toggleStar(sound) {
  if (!sound) return Promise.resolve(false);
  return store.dispatch("toggleStar", { hash: sound.hash });
}

// The sound's share link (GET /loops/<h>/link) with the sharer as referrer.
export async function shareLink(sound, me) {
  try {
    const res = await apiGet(`/loops/${encodeURIComponent(sound.hash)}/link`);
    if (!res || !res.url) throw new Error("no link");
    const url = new URL(res.url);
    if (me) url.searchParams.set("via", me);
    const text = url.toString();
    const subject = `${sound.title} by ${sound.creatorDisplay || sound.creator} on cloudloop`;
    if (navigator.share && document.documentElement.dataset.density === "touch") {
      await navigator.share({ title: subject, url: text }).catch(() => {});
      return text;
    }
    await navigator.clipboard.writeText(text);
    toast("Link copied");
    return text;
  } catch (e) {
    toast("Couldn't get a link to that sound.");
    return null;
  }
}

export function menuFor(sound, me, { compact = false } = {}) {
  if (!sound) return [];
  // compact: the menu inside the details sheet itself leaves out Details.
  const items = compact
    ? []
    : [{ title: "Details", icon: "mdi-information-outline", onClick: () => soundSheets.open("details", sound) }];
  if (canDownload(sound)) {
    items.push({ title: "Download", icon: "mdi-download", onClick: () => download(sound) });
  } else if (canBuy(sound)) {
    items.push({ title: "Buy…", icon: "mdi-cart-outline", onClick: () => soundSheets.open("buy", sound) });
  }
  if (canAddToSession(sound)) {
    items.push({ title: "Add to session…", icon: "mdi-plus-circle-outline", onClick: () => addToSession(sound) });
  }
  if (me) {
    const starred = isStarred(sound);
    items.push({
      title: starred ? "Unstar" : "Star",
      icon: starred ? "mdi-star" : "mdi-star-outline",
      onClick: () => toggleStar(sound),
    });
  }
  items.push({ title: "Share link…", icon: "mdi-link-variant", onClick: () => shareLink(sound, me) });
  if (me && sound.creator === me) {
    items.push({ divider: true });
    items.push({ title: "Rename…", icon: "mdi-pencil-outline", onClick: () => soundSheets.open("rename", sound) });
    items.push({ title: "Set price…", icon: "mdi-tag-outline", onClick: () => soundSheets.open("setPrice", sound) });
    items.push({ title: "Edit details…", icon: "mdi-tune", onClick: () => soundSheets.open("editDetails", sound) });
  }
  return items;
}

export default { menuFor, download, toggleStar, isStarred, shareLink };
